export const ReportIds = {
    Negative_SOH: 6,
    Sales_By_Type: 50,
    Negative_GP_Sales: 51,
} as const;